import React from 'react';
import { assetToAssetType } from '../../validatingElements';
import { AssetTemplate } from './AssetTemplate';

export function AssetTemplateList(props: {
    assets?:
        | {
              assetId?: undefined | string;
              id?: undefined | string;
              description?: undefined | string | null;
              type?: undefined | string;
              filenameThumbnail?: undefined | string | null;
          }[]
        | undefined;
    canRemove?: boolean | undefined;
    canEditDescription?: boolean | undefined;
    canAddAnnotations?: boolean | undefined;
    isShowDescription?: boolean | undefined;
    surveyId?: string | undefined;
    objectId?: string | undefined;
    equipmentId?: string | undefined;
    onAssetUpdated?(): Promise<void>;
}) {
    if (!props.assets) {
        return null;
    }

    return (
        <>
            {' '}
            {props.assets.map((asset, i: number) => (
                <div className="col-sm-6 col-md-3" key={asset.assetId ?? asset.id!}>
                    <AssetTemplate
                        id={asset.assetId ?? (asset.id as string as any)}
                        order={i}
                        {...asset}
                        type={assetToAssetType(asset)}
                        canRemove={props.canRemove}
                        canAddAnnotations={props.canAddAnnotations}
                        canAddToStartPage
                        returnUrl={window.location.pathname}
                        canEditDescription={props.canEditDescription}
                        isShowDescription={props.isShowDescription}
                        surveyId={props.surveyId ? props.surveyId : undefined}
                        objectId={props.objectId ? props.objectId : undefined}
                        equipmentId={props.equipmentId}
                        onAssetsChanged={async () => {
                            if (props.onAssetUpdated) {
                                await props.onAssetUpdated();
                            }
                        }}
                        onAssetRemoved={async () => {
                            if (props.onAssetUpdated) {
                                await props.onAssetUpdated();
                            }
                        }}
                        description={asset.description}
                    />
                </div>
            ))}
        </>
    );
}
